import {
	GridColumnProps,
	GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import i18n from "../../../../i18n";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell } from "ui/grid/GridCommandCell";
import { CLASSNAME } from "utils/constant";
import { FC } from "react";
import GroupHeaderCell from "../cells/GroupHeaderCell";

let t = i18n.t;

export const FrozenSalesColumnItem = () => {
	const gridItems: GridColumnProps[] = [
		{
			field: "productText",
			title: t("Product"),
			// cells: {
			// 	data: (props) => <CellPopover {...props} />,
			// 	// groupHeader: (props) => <GroupHeaderCell {...props} />,
			// },
			className: `no-border`,
		},

		{
			field: "netLiveWeightKg",
			title: t("Weight"),
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kg"} style={{}} />,

				headerCell: (props) => <NumericalHeader {...props} />,
				// groupFooter: (props) => <GroupHeaderCell {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "maxPrice",
			title: t("HighestPrice"),
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,

				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "averagePrice",
			title: t("AveragePrice"),
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,

				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "",
			title: "",
			className: `no-border`,
		},
	];
	return gridItems;
};

const NumericalHeader: FC<
	GridHeaderCellProps & { style?: React.CSSProperties } & any
> = (props) => {
	return (
		<th style={{ ...props.style, textAlign: "end", paddingRight: "10px" }}>
			{props.title}
		</th>
	);
};
